<template>
  <li
    class="p-team-user-profile-list__item"
    name="mailArea"
    :class="{'is-active': isActive}"
  >
    <div class="p-team-user-profile__title">ログインID</div>
    <div class="p-team-user-profile__text">{{ mail }}</div>
    <div class="p-team-user-profile__editor p-team-user-profile__editor--id">
      <div
        class="c-input"
        :class="{'is-error': valid.mail != ''}"
      >
        <div class="c-input__title">新しいログインID</div>
        <input
          v-model="inputMail"
          class="c-input__item"
          type="text"
          name="mail"
          placeholder="新しいログインIDを入力してください"
          @blur="onChangeMail"
          @input="onChangeMail"
        />
        <div
          class="c-error c-error--balloon"
          :class="{'is-active': valid.mail != ''}"
        >
          <div class="c-error__text">{{ valid.mail }}</div>
        </div>
      </div>
      <div
        class="c-input"
        :class="{'is-error': valid.mailConf != ''}"
      >
        <div class="c-input__title">新しいログインID（確認）</div>
        <input
          v-model="inputMailConf"
          class="c-input__item"
          type="text"
          name="mail_conf"
          value=""
          placeholder="確認のため、再度入力してください"
          @blur="onChangeMailConf"
          @input="onChangeMailConf"
        />
        <div
          class="c-error c-error--balloon"
          :class="{'is-active': valid.mailConf != ''}"
        >
          <div class="c-error__text">{{ valid.mailConf }}</div>
        </div>
      </div>
    </div>
    <div class="p-team-user-profile__switch">
      <div v-show="editable" class="c-text">
        <a @click="onToggleMailClick">変更する</a>
      </div>
    </div>
    <div class="p-team-user-profile__btns p-team-user-profile__btns--id">
      <a
        class="c-btn c-btn--gray u-w120 u-h30"
        @click="onCancelMailClick($event)"
      >
        <p class="c-btn__text">キャンセル</p>
      </a>

      <button
        :class="{'is-loading': isLoading}"
        class="c-btn c-btn--blue u-w120 u-h30"
        type="button"
        name="add_mail"
        value="add-user"
        :disabled="isLoading || valid.mail != '' || valid.mailConf != ''"
        @click="onChangeMailClick($event)"
      >
        <p class="c-btn__text">保存する</p>
      </button>
    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </li>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    initialMail: String,
    editable: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      mail: this.initialMail,
      inputMail: null,
      inputMailConf: null,
      errorMessage: '',
      isError: false,
      isLoading: false,
      isActive: false,
      valid: {
        mail: '',
        mailConf: '',
      }
    }
  },
  methods: {
    onToggleMailClick: function() {
      this.isActive = !this.isActive;
    },


    onChangeMail:  function() {
      if (!this.inputMail || this.inputMail == '') {
        this.valid.mail = '新しいログインIDを入力してください';
      } else {
        this.valid.mail = '';
      }
    },

    onChangeMailConf:  function(_event) {
      if (!this.inputMailConf || this.inputMailConf == '') {
        this.valid.mailConf = '新しいログインID（確認）を入力してください';
      } else {
        this.valid.mailConf = '';
      }
    },

    showError: function(errors) {
      for (let elementName in errors) {
        let message = errors[elementName];

        // エラーメッセージ表示設定
        $('input[name=' + elementName + ']')
          .parent()
          .find('.c-error')
          .addClass('is-active')
          .find('.c-error__text')
          .text(message)
      }
    },

    onCancelMailClick: function(_event) {
      this.isActive = false;
    },

    onChangeMailClick: function(event) {
      event.preventDefault();
      this.isLoading = true;

      // 入力バリデーション実行: 基本パターン
      this.onChangeMail();
      this.onChangeMailConf();

      // 入力バリデーション実行: 特殊パターン
      if(this.inputMail != this.inputMailConf) {
        this.valid.mail = 'ログインIDが一致していません';
        this.valid.mailConf = 'ログインIDが一致していません';
      }

      // 入力値検証結果に1つでも問題があった場合は処理終了
      if (this.valid.mail != ''|| this.valid.mailConf != '') {
        setTimeout(() => { this.isLoading = false; }, 300);
        return;
      }

      // ペイロードデータの作成
      const data = {
        mail: this.inputMail,
      };

      axios.post('/api/team/update-mail',data)
        .then(res => {
          if(this.handleResponse(res, false)){
            this.mail = res.data.mail;
            this.isActive = false;
          } else {
            if(res.data.errors){
              Object.keys(res.data.errors).forEach((index) => {
                if (typeof this.valid[this.camelCase(index)] === 'undefined') return;
                this.valid[this.camelCase(index)] = res.data.errors[index];
              });
            }
            if(res.data.message){
              this.isError = true;
              this.errorMessage = res.data.message
            }
          }
          setTimeout(() => { this.isLoading = false; }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'ログインIDの更新に失敗しました'
          setTimeout(() => { this.isLoading = false; }, 300);
          if(error.response && error.response.status == 401) {
            location.href = "/coins-admin";
            return;
          }
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  },

}
</script>
